const itemMapper = children => item => {
  return {
    title: item.title,
    type: item.type,
    short: item.alias.substring(0, item.alias.length - 3),
    link: item.link,
    query: item.query,
    ...(children
      ? item.children
        ? { children: item.children.map(itemMapper(false)) }
        : {}
      : {})
  };
};

export default function modelContentMenu(item) {
  return item.context.menu ? item.context.menu.map(itemMapper(true)) : [];
}

export function modelFlatContentMenu(item) {
  let items = [
    ...(item.context.menu ? item.context.menu.map(itemMapper(false)) : [])
  ];
  if (item.context.menu) {
    item.context.menu.forEach(item => {
      if (item.children) {
        item.children.forEach(item => {
          if (item.type !== "separator") {
            items.push(itemMapper(false)(item));
          }
        });
      }
    });
  }

  let returnable = {};
  items.forEach(item => {
    if (item.short) {
      returnable[item.short] = item;
    }
  });

  return returnable;
}



// WEBPACK FOOTER //
// ./src/redux/models/contentMenu.js